import { render } from "./EsopDetails.vue?vue&type=template&id=61b00472&scoped=true"
import script from "./EsopDetails.vue?vue&type=script&lang=js"
export * from "./EsopDetails.vue?vue&type=script&lang=js"

import "./EsopDetails.vue?vue&type=style&index=0&id=61b00472&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b00472"]])

export default __exports__